import { AcquisitionService } from './../../../../../acquisition/src/lib/services/acquisition.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ReportReferenceDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-report-reference',
  templateUrl: './report-reference.component.html',
  styleUrls: ['./report-reference.component.scss']
})
export class ReportReferenceComponent implements OnInit {


  reportRefForm: FormGroup;
  reportRefFormArray: FormGroup;
  control = new FormControl();
  reportRefs: ReportReferenceDto[] = [];
  @Output() reportRef = new EventEmitter<ReportReferenceDto[]>()
  @Output() deleteReportRefEvent = new EventEmitter<any>()

    selectedReportRef: any;
    filteredDelete: Array<any> =[];
    loading = false;
    selectedIndex = null;

    constructor(
     private fb: FormBuilder,
     private acquisitionService: AcquisitionService,
     ) {}

    ngOnInit() {

      this.createReportRefForm();
    }

    createReportRefForm() {
      this.reportRefForm = this.fb.group({
        CompanyName: ['', Validators.required],
        Logo: [''],
        id: null
        });
        this.reportRefFormArray = this.fb.group({ ReportRefs: this.fb.array([])
          });
        this.acquisitionService.getReportRef().subscribe(res => {
          this.setReportRef([res]);
        });

    }

  // method to display reportRefs
  setReportRef(reportRefs) {

    const control  = this.reportRefFormArray.controls.ReportRefs as FormArray;
    control.clear();
    reportRefs.forEach( e => {
      control.push(
        this.fb.group({
          CompanyName: e.CompanyName,
          Logo: e.Logo,
          id: e.id
        })
      );
    });
  }


  onFilesAdded(event) {
    const [file] = event.target.files;
    // this.getFileName = file?.name;
    this.reportRefForm.patchValue({
      // FileName:file.name,
      // FileType:file.type,
      Logo:file,
      });
  }


  // method to add ReportRef
  addReportRef(value: ReportReferenceDto) {
    const control  = this.reportRefFormArray.controls.ReportRefs as FormArray;
    control.insert(0,
          this.fb.group({
            CompanyName: value.CompanyName,
          Logo: value.Logo,
            id: null
          })
       );
  }

  selectReportRef(value) {}

  // method to delete reportRef from arrary list
  deleteReportRef(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.reportRefFormArray.controls.ReportRefs as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.reportRefs.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.reportRefs[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: ReportReferenceDto) {
    if(this.reportRefForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.reportRefFormArray.get('ReportRefs')['controls'][this.selectedIndex].patchValue({...formValue});
    } else {
      this.addReportRef(formValue);
    }
    this.selectedIndex = null;
    this.reportRefForm.reset()
  }

  onEdit(index, value: ReportReferenceDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.reportRefForm.patchValue({...value});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.reportRefForm.reset();
  }

  onSubmit(formValue: ReportReferenceDto[]) {
    this.loading = true;
    const form = formValue['ReportRefs'][0];
    this.acquisitionService.uploadFile(form['Logo'], {
      CompanyName: form['CompanyName'],
      id: form['id'] ? form['id'] : undefined,
      Logo: form['Logo'] ? form['Logo'] : undefined,

    }).subscribe(res => {
      this.setReportRef([res]);
      this.loading = false;
    });

  }

}
